import { useEffect } from 'react';
import Routes from './Routes';
import { initializeUTMTracking } from './utils/utmTracker';

function App() {
  useEffect(() => {
    // Initialize UTM tracking on app mount
    initializeUTMTracking();
  }, []);

  return <Routes />;
}

export default App;